import { useMutation, useQueryClient } from '@tanstack/react-query'
import { client } from '../client'
import { queryKeys } from '../keys'

// Set subscription status for an account
export function useSetSubscription() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({
      accountName,
      hasSubscription,
    }: {
      accountName: string
      hasSubscription: boolean
    }) => {
      const { data, error } = await client.PUT(
        '/api/v1/subscriptions/{account_name}',
        {
          params: { path: { account_name: accountName } },
          body: { has_subscription: hasSubscription },
        },
      )
      if (error) throw error
      return data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.subscriptions.all })
      // Also invalidate next-free-time queries since subscription affects them
      queryClient.invalidateQueries({
        queryKey: ['accounts'],
        predicate: (query) =>
          query.queryKey.length >= 3 && query.queryKey[2] === 'next-free-time',
      })
    },
  })
}
